import SystemProperty from "./SystemProperty";

export const appEnv = () => SystemProperty.getProperty("env");
export const baseExpApi = () => SystemProperty.getProperty("base_exp_api");
export const forgeIAMAPI = () => SystemProperty.getProperty("forge_iam_api");
export const forgeIAMClientId = () =>
  SystemProperty.getProperty("forge_iam_client_id");
export const dataunityBase = () =>
  SystemProperty.getProperty("data_unity_base");

export const getProperty = (prop: string) => {
  return isAks() ? systemProperties[`aks_${prop}`] : systemProperties[prop];
};

export const isAks = () => window.location.hostname.includes("fdu");

export const systemProperties: { [x: string]: string } = {
  // PROD
  env_prod: "production",
  forge_iam_client_id_prod: "CAM-Project-CAM-app-7822dd",
  forge_iam_api_prod: "https://forge-sso.spec.honeywell.com",
  base_exp_api_prod:
    "https://cam-experience-api-xueqpkwi-prod-wraisjgf.apps.prod.aks.forgeapp.honeywell.com/api",

  // STAGE
  env_stage: "insights.cam.ui",
  forge_iam_client_id_stage: "nba-polaris-forgeinsights-ui",
  forge_iam_api_stage: "https://forge-identity-qa.dev.spec.honeywell.com",
  base_exp_api_stage:
    "https://api.dev.ianalytics.honeywell.com/insights-exp-qa", // 'https://api.dev.ianalytics.honeywell.com/insights-exp-stage'

  // PERFORMANCE
  env_performance: "performance",
  forge_iam_client_id_performance: "insights.cam.ui",
  forge_iam_api_performance: "https://forge-identity-qa.dev.spec.honeywell.com",
  base_exp_api_performance:
    "https://cam-experience-api-xueqpkwi-performance-wraisjgf.apps.psr.aks.forgeapp.honeywell.com/api",

  // QA
  env_qa: "qa",
  forge_iam_client_id_qa: "insights.cam.ui",
  forge_iam_api_qa: "https://forge-identity-qa.dev.spec.honeywell.com",
  base_exp_api_qa: "https://cam-api-dev.hia.honeywell.com/cam-exp-qa",

  // DEV
  env_dev: "dev",
  forge_iam_client_id_dev: "insights.cam.ui",
  forge_iam_api_dev: "https://forge-identity-qa.dev.spec.honeywell.com",
  base_exp_api_dev: "https://cam-api-dev.hia.honeywell.com/cam-exp-dev",

  // local
  env_local: "local",
  forge_iam_client_id_local: "insights.cam.ui",
  forge_iam_api_local: "https://forge-identity-qa.dev.spec.honeywell.com",
  base_exp_api_local: "https://cam-api-dev.hia.honeywell.com/cam-exp-dev",
  // base_exp_api_local: "http://localhost:3001/api",

  // AKS
  aks_forge_iam_api_prod: "https://forge-sso.spec.honeywell.com",
  aks_base_exp_api_prod:
    "https://cam-experience-api-xueqpkwi-prod.apps.os.aro.forgeapp.honeywell.com/api",
  aks_data_unity_base_prod: "https://fdu-qa.honeywell.com",

  // STAGE
  aks_env_stage: "insights.cam.ui",
  aks_forge_iam_client_id_stage: "nba-polaris-forgeinsights-ui",
  aks_forge_iam_api_stage: "https://forge-identity-qa.dev.spec.honeywell.com",
  aks_base_exp_api_stage:
    "https://api.dev.ianalytics.honeywell.com/insights-exp-qa", // 'https://api.dev.ianalytics.honeywell.com/insights-exp-stage'
  aks_data_unity_base_stage: "https://fdu-qa.honeywell.com",

  // PERFORMANCE
  aks_env_performance: "insights.cam.ui",
  aks_forge_iam_client_id_performance: "nba-polaris-forgeinsights-ui",
  aks_forge_iam_api_performance:
    "https://forge-identity-qa.dev.spec.honeywell.com",
  aks_base_exp_api_performance:
    "https://api.dev.ianalytics.honeywell.com/insights-exp-performance",
  aks_data_unity_base_perfomance: "https://fdu-qa.honeywell.com",

  // QA
  aks_env_qa: "qa",
  aks_forge_iam_client_id_qa: "insights.cam.ui",
  aks_forge_iam_api_qa: "https://forge-identity-qa.dev.spec.honeywell.com",
  aks_base_exp_api_qa: "https://cams-exp-api.fdu-qa.honeywell.com/api",
  aks_data_unity_base_qa: "https://fdu-qa.honeywell.com",

  // DEV
  aks_env_dev: "dev",
  aks_forge_iam_client_id_dev: "insights.cam.ui",
  aks_forge_iam_api_dev: "https://forge-identity-qa.dev.spec.honeywell.com",
  aks_base_exp_api_dev: "https://cams-exp-api.fdu-dev.honeywell.com/api",
  aks_data_unity_base_dev: "https://fdu-qa.honeywell.com",

  // local
  aks_env_local: "local",
  aks_forge_iam_client_id_local: "insights.cam.ui",
  aks_forge_iam_api_local: "https://forge-identity-qa.dev.spec.honeywell.com",
  aks_base_exp_api_local: "https://cams-exp-api.fdu-qa.honeywell.com/api",
  aks_data_unity_base_local: "https://fdu-qa.honeywell.com",
};
